import React from "react";
import '../HomeStyles.css'
import {HorizontalSeparator} from "../../separators/Separators";
import Images from "../../../assets/images/Images";
import { useTranslation } from "react-i18next";
// @ts-ignore
import {animateScroll} from "react-scroll";

const ContentComponent = () => {
    const { t } = useTranslation();

    return (
        <div id='scrollContainer' className={'homeContentContainer'}>
            <div className={'languageSelector'} />

            <div className={'scrollContainer'} id='scrollContainer'>
                <h3 className={'titleHome'}>{ t('home.presentation.title') }</h3>
                <HorizontalSeparator/>
                <p className={'homeParagraph'}>
                    { t('home.presentation.paragraph1') }
                </p>
                <p className={'homeParagraph'}>
                    { t('home.presentation.paragraph2') }
                </p>
            </div>
        </div>
    )
};

export default ContentComponent;
